/**
 * One product label for the assistant (contract C8). Every user-visible text that names the assistant uses it, so a
 * rename is a one-line change.
 */
export const ASSISTANT_LABEL = 'Ask HaulierMagic';
